import {AxiosError} from 'axios'

import {API} from '../../../networking/http'
import {QueryOptions, UseQueryOptions} from '../../helpers/types'
import {MembershipCancelRequest} from '../types'

export type GetMembershipCancelRequestsParams = string
export type GetMembershipCancelRequestsQueryParams = undefined

// Newest first. At most one of them is open (status 'requested').
export type GetMembershipCancelRequestsReturnType = MembershipCancelRequest[]

type Par = QueryOptions<
  GetMembershipCancelRequestsParams,
  GetMembershipCancelRequestsQueryParams,
  GetMembershipCancelRequestsReturnType
>

type QueOp = UseQueryOptions<
  GetMembershipCancelRequestsReturnType,
  AxiosError,
  GetMembershipCancelRequestsReturnType,
  [string, GetMembershipCancelRequestsParams?]
>

// The server answers {items: [...]}; a bare array is accepted too. Anything else is an empty list,
// because a non-array here crashed the pass page and its error boundary sent the user to the venue home (#1364).
type CancelRequestsResponse = {items?: MembershipCancelRequest[]} | MembershipCancelRequest[] | null | undefined

export const toCancelRequestList = (data: CancelRequestsResponse): MembershipCancelRequest[] => {
  if (Array.isArray(data)) {
    return data
  }
  return Array.isArray(data?.items) ? data.items : []
}

export const makeGetMembershipCancelRequestsEndpoint = (subscriptionId: string) =>
  `memberships/${subscriptionId}/cancel-requests`

export const getMembershipCancelRequests = ({params: subscriptionId}: Par): QueOp => ({
  queryKey: ['getMembershipCancelRequests', subscriptionId],
  enabled: Boolean(subscriptionId),
  queryFn: () => {
    if (!subscriptionId) {
      return Promise.resolve([])
    }
    return API.get<GetMembershipCancelRequestsQueryParams, CancelRequestsResponse>(
      makeGetMembershipCancelRequestsEndpoint(subscriptionId),
    ).then((res) => toCancelRequestList(res.data))
  },
})
